import { AddToCalendarButton } from "./AddToCalendarButton";
import { formatLivestreamStartSchedule } from "./livestreamSchedule";

export function LivestreamStartDateDisplay({
  start,
  end,
  eventTitle,
  meetingUrl,
}: {
  start?: string | null;
  end?: string | null;
  eventTitle?: string;
  meetingUrl?: string;
}) {
  if (!start) return null;

  const schedule = formatLivestreamStartSchedule({ start });
  if (!schedule) return null;

  return (
    <div className="mt-3 space-y-3">
      <div className="space-y-0.5">
        <p className="text-base text-white/70">{schedule.date}</p>
        <p className="text-sm text-gray-400">{schedule.time}</p>
      </div>
      {eventTitle ? (
        <AddToCalendarButton
          title={eventTitle}
          start={start}
          end={end}
          url={meetingUrl}
        />
      ) : null}
    </div>
  );
}
